import request from '@api/request'
const BASE_URL = 'lishui-gov'

// 根据openId查询绑定企业
export const getEntByOpenId = params =>
  request.get(BASE_URL + '/weChat/getEntByOpenId', { params })

// 精准搜索企业
export const getEntInfoByName = params =>
  request.get(BASE_URL + '/weChat/getEntInfoByName', { params })

// 绑定员工信息
export const addEmployeeInfo = params =>
  request.post(BASE_URL + '/weChat/addEmployeeInfo', params)
